export function formatDate(date: Date, pattern: string) {
  const dd = `0${date.getDate()}`.slice(-2);
  const mm = `0${date.getMonth() + 1}`.slice(-2);
  const yyyy = date.getFullYear().toString();

  return pattern.toLowerCase().replace('dd', dd).replace('mm', mm).replace('yyyy', yyyy);
}
